export const OPTIONS = [
    {
      id: 2,
      name: 'Twitter (280)',
      charLimit: 280,
    },
    {
      id: 1,
      name: 'Custom',
      charLimit: 300,
    },
    {
      id: 9,
      name: 'Instagram Caption (2200)',
      charLimit: 2200,
    },
    {
      id: 10,
      name: 'TikTok Caption (2200)',
      charLimit: 2200,
    },
    {
      id: 4,
      name: 'LinkedIn Status (700)',
      charLimit: 700,
    },
    {
      id: 6,
      name: 'LinkedIn Group Discussions (2000)',
      charLimit: 2000,
    },
    {
      id: 3,
      name: 'LinkedIn Post (3000)',
      charLimit: 3000,
    },
    {
      id: 7,
      name: 'LinkedIn Comment (1300)',
      charLimit: 1300,
    },
    {
      id: 8,
      name: 'Facebook Comment (8000)',
      charLimit: 8000,
    },
    {
      id: 11,
      name: 'Google My Business Post (1500)',
      charLimit: 1500,
    },
]